import { IAcceptanceObject } from "../../interfaces/IAcceptanceObject";
import { setACCEPTANCEOBJECT } from "../constants/acceptanceObject.types";

export const setAcceptanceObject = (acceptanceObject: IAcceptanceObject) => {
  return {
    type: setACCEPTANCEOBJECT,
    payload: acceptanceObject,
  };
};
